import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useAuth } from 'hooks/auth';
import { baseURL } from 'services/api';
import { useCallback } from 'react';
import { multiSelectorOptionsMapper, optionsMapper } from './utils';

type Product = {
  id: number;
  code: string;
  name: string;
};

export const useProductOptions = () => {
  const { token } = useAuth();

  const fetchProducts = useCallback(async () => {
    const { data } = await axios.get<Product[]>(`${baseURL.api}/products`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data.map((p) => ({
      value: p.id.toString(),
      label: `${p.code} - ${p.name}`,
    }));
  }, [token]);

  const { isPending, data } = useQuery({
    queryKey: ['fetchProducts'],
    queryFn: () => fetchProducts(),
  });

  return {
    singleSelectOptions: data ? data.map(optionsMapper) : [],
    multiSelectOptions: data ? data.map(multiSelectorOptionsMapper) : [],
    loading: isPending,
  };
};
